// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_jf-1";
export var rowFirst = "_jf-3";
export var rowLast = "_jf-5";
export var rowMiddle = "_jf-4";
export var ticketListScroll = "_jf-2";
export var ticketStack = "_jf-0";